export default __webpack_public_path__ + "static/frame-3-deb0a1cfae8521f7c393a84bc1f1530e.png";